"use strict";

require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.timers.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var React = _interopRequireWildcard(require("react"));
var _classnames10 = _interopRequireDefault(require("classnames"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var FormItem = function FormItem(props) {
  var className = props.className,
    airlabel = props.airlabel,
    required = props.required,
    disabled = props.disabled,
    readonly = props.readonly,
    active = props.active,
    status = props.status,
    message = props.message,
    label = props.label,
    htmlFor = props.htmlFor,
    children = props.children,
    _onClick = props.onClick;
  var prefixCls = 'unv-form';
  var comCls = (0, _usePrefixCls.usePrefixCls)('form');
  var airlabelHandles = {};
  var itemRef = React.useRef(null);
  var _React$useState = React.useState(false),
    _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
    focus = _React$useState2[0],
    setFocus = _React$useState2[1];
  var _React$useState3 = React.useState(false),
    _React$useState4 = (0, _slicedToArray2.default)(_React$useState3, 2),
    action = _React$useState4[0],
    setAction = _React$useState4[1];

  // 获得焦点处理
  var focusHandle = function focusHandle() {
    setFocus(true);
  };
  // 失去焦点事件
  var blurHandle = function blurHandle() {
    setFocus(false);
  };
  if (airlabel) {
    airlabelHandles = {
      onFocus: focusHandle,
      onBlur: blurHandle
    };
  }
  React.useEffect(function () {
    if (airlabel && itemRef) {
      var inputNode = itemRef.current.querySelector('input') || itemRef.current.querySelector('textarea');
      if (inputNode) {
        if (inputNode.type === 'hidden') {
          // 如果是像 select 这些隐藏一个 input 来监听的，则用 MutationObserver 来处理
          var config = {
            attributes: true
          };
          var observer = new MutationObserver(function (mutationsList) {
            mutationsList.forEach(function (mutation) {
              if (mutation.type === 'attributes') {
                setAction(inputNode.value);
              }
            });
          });
          observer.observe(inputNode, config);
        } else {
          inputNode.addEventListener('change', function () {
            setAction(inputNode.value);
          });
        }
        setTimeout(function () {
          if (inputNode.value) {
            setAction(true);
          }
        }, 0);

        // fix browser autofill
        var startTime = Date.now();
        var initialBgColor = getComputedStyle(inputNode).backgroundColor;
        var timer = setInterval(function () {
          try {
            var currentBgColor = getComputedStyle(inputNode).backgroundColor;
            if (initialBgColor !== currentBgColor) {
              setAction(true);
              clearInterval(timer);
            } else if ((Date.now() - startTime) / 1000 > 3) {
              clearInterval(timer);
            }
          } catch (err) {
            clearInterval(timer);
          }
        }, 100);
      }
    }
  }, []);
  var formItemClassName = (0, _classnames10.default)("".concat(prefixCls, "__item"), "".concat(comCls, "__item"), (0, _defineProperty2.default)({}, "".concat(prefixCls, "__item--airlabel"), airlabel), (0, _defineProperty2.default)({}, "is-".concat(status), status), (0, _defineProperty2.default)({}, "is-required", required), (0, _defineProperty2.default)({}, "is-disabled", disabled), (0, _defineProperty2.default)({}, "is-readonly", readonly), (0, _defineProperty2.default)({}, "is-active", active), (0, _defineProperty2.default)({}, "is-focus", focus), (0, _defineProperty2.default)({}, "".concat(prefixCls, "__item--airlabel-action"), action), (0, _defineProperty2.default)({}, "is-click", typeof _onClick === 'function'), className);
  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
    className: formItemClassName,
    ref: itemRef
  }, airlabelHandles, {
    onClick: function onClick() {
      if (typeof _onClick === 'function') {
        _onClick(props);
      }
    }
  }), Boolean(label) && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "__item-label")
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: htmlFor
  }, label)), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "__item-controls")
  }, children, Boolean(message) && /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefixCls, "__item-message")
  }, message)));
};
var _default = exports.default = FormItem;